import {headerEvents} from "./modules/headerEvents";
import {scrollTo} from "./modules/scrollTo";
import {formValidate} from "./modules/formValidate";
import {customScriptPluginMember} from "./customise/customScriptPluginMember";

let $ = jQuery;

//common
$(function () {
    headerEvents();
    scrollTo();
    formValidate();
    customScriptPluginMember();
})